import { FC } from 'react';

import { FeatureName, MerchantProviderType } from '__generated__/GQL';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';
import Text from 'components/_core/Text';

import { StripeOnboarding } from '../StripeOnboarding';
import locales from './locales';

interface MerchantOnboardingProps {
  onExit: () => void;
  providerType: MerchantProviderType;
}

export const MerchantOnboarding: FC<MerchantOnboardingProps> = ({
  onExit,
  providerType,
}) => {
  const { canAccessFeature } = useCanCompanyUserAccessFeature();

  if (!canAccessFeature({ name: FeatureName.Merchant })) {
    return <Text>{locales.waitForOnboarding}</Text>;
  }

  return (
    <>
      {providerType === MerchantProviderType.Stripe ? (
        <StripeOnboarding onExit={onExit} />
      ) : null}
    </>
  );
};
